import { render, staticRenderFns } from "./SwitchDialog.vue?vue&type=template&id=11268ae6&scoped=true&"
import script from "./SwitchDialog.vue?vue&type=script&lang=js&"
export * from "./SwitchDialog.vue?vue&type=script&lang=js&"
import style0 from "./SwitchDialog.vue?vue&type=style&index=0&id=11268ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11268ae6",
  null
  
)

export default component.exports